<template>
<div class="section">
  <div class="container has-max-width">
    <b-field label="Game Name" custom-class="is-large">
      <b-input size="is-large"></b-input>
    </b-field>
    <div class="level space-top">
      <div class="level-left">
        <div class="level-item">
          <router-link :to="{ name: 'ub-home' }" class="is-large button">
            <span class="icon">
              <i class="fas fa-arrow-circle-left"></i>
            </span>
            <span>Back</span>
          </router-link>
        </div>
      </div>
      <div class="level-right">
        <div class="level-item">
          <button @click="createRoom" class="button is-primary is-large">
            <span>Create Game</span>
            <span class="icon">
              <i class="fas fa-arrow-circle-right"></i>
            </span>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
export default {
  name: 'ub-create-game',
  props: [],
  data() {
    return {
    };
  },
  computed: {
  },
  methods: {
    createRoom() {
      this.$router.push({
        name: 'ub-lobby',
      });
    },
  },
  mounted() {
  },
  components: {
  },
};
</script>

<style lang="scss" scoped>
</style>
